import Vue from "vue";
import VueRouter from "vue-router";
import Index from '@/views/index/index.vue'

// 注册vue-router
Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'Index',
		component: Index
	}
];

const router = new VueRouter({
	mode: "history",
	routes
});

export default router;